import { graphql } from '@/graphql-setup'

export const EXPORT_SALARY_ITEM_GENERATION_PREVIEW_MUTATION = graphql(`
  mutation ExportSalaryItemGenerationPreview(
    $year: Int!
    $month: Int!
    $exportFormat: ExportFormat!
  ) {
    exportSalaryItemGenerationPreview(
      year: $year
      month: $month
      exportFormat: $exportFormat
    ) {
      ok
      exportId
      exportTimeout
    }
  }
`)
